import { render, staticRenderFns } from "./ModalCompleted.vue?vue&type=template&id=2272a642&scoped=true&"
import script from "./ModalCompleted.vue?vue&type=script&lang=js&"
export * from "./ModalCompleted.vue?vue&type=script&lang=js&"
import style0 from "./ModalCompleted.vue?vue&type=style&index=0&id=2272a642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2272a642",
  null
  
)

export default component.exports